import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { forwardRef } from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const ToolbarMenu = _ref => {
  let {
    direction = 'vertical',
    items = [],
    active = -1,
    hiddenItems = {},
    errorIndicators = {},
    classNames = {},
    children,
    onChange
  } = _ref;
  return /*#__PURE__*/_jsx("nav", {
    className: clsx(styles.menu, classNames.menu),
    children: /*#__PURE__*/_jsxs("ul", {
      className: clsx(styles.menuList, styles[`menuList--${direction}`]),
      children: [items.map(item => {
        if (hiddenItems[item.id]) return null;
        const hasError = errorIndicators[item.id];
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(MenuItem, _objectSpread(_objectSpread({}, item), {}, {
            classNames: {
              menuItem: classNames.menuItem,
              menuItemIcon: classNames.menuItemIcon,
              menuItemTitle: classNames.menuItemTitle
            },
            active: active === item.id,
            hasError: hasError,
            onClick: () => onChange(item.id)
          }))
        }, `toolbar-menu-${item.title}-${item.id}`);
      }), children]
    })
  });
};

export const MenuItem = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    icon,
    title,
    classNames = {},
    indicator = false,
    active = false,
    hasError = false,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = _ref2;
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    type: "button",
    className: clsx(styles.menuItem, {
      [styles['menuItem--active']]: active,
      [styles['menuItem--hasError']]: hasError,
      [classNames.menuItemActive]: active
    }, classNames.menuItem)
  }, onClick && {
    onClick
  }), onMouseEnter && {
    onMouseEnter
  }), onMouseLeave && {
    onMouseLeave
  }), {}, {
    children: [/*#__PURE__*/_jsx("span", {
      className: clsx(styles.menuItem__icon, classNames.menuItemIcon),
      children: icon
    }), /*#__PURE__*/_jsx("span", {
      className: clsx(styles.menuItem__title, classNames.menuItemTitle),
      children: title
    }), !active && indicator || hasError ? /*#__PURE__*/_jsx("span", {
      className: styles.menuItem__indicator
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  }));
});
MenuItem.displayName = 'MenuItem';
export default ToolbarMenu;